import * as React from "react";

const Loader = ({
  width = "216px",
  height = "24px",
  color = "#ffffff",
  ...props
}) => (
  <div style={{ position: "relative", width, height }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 84 16"
      width={width}
      height={height}
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)"
      }}
      {...props}
    >
      <circle cy={8} r={0} fill={color} transform="translate(28)">
        <animate
          attributeName="r"
          begin={0}
          calcMode="spline"
          dur="1.2s"
          keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8"
          repeatCount="indefinite"
          values="0; 4; 0; 0"
        />
      </circle>
      <circle cy={8} r={0} fill={color} transform="translate(42)">
        <animate
          attributeName="r"
          begin={0.3}
          calcMode="spline"
          dur="1.2s"
          keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8"
          repeatCount="indefinite"
          values="0; 4; 0; 0"
        />
      </circle>
      <circle cy={8} r={0} fill={color} transform="translate(56)">
        <animate
          attributeName="r"
          begin={0.6}
          calcMode="spline"
          dur="1.2s"
          keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8"
          repeatCount="indefinite"
          values="0; 4; 0; 0"
        />
      </circle>
    </svg>
  </div>
);

export default Loader;
